import React, { useState, useRef, useEffect } from 'react';
import './Homepage.css';
import ChatBox from "../components/chatbot/ChatBox";
import DisclaimerPopup from "../components/DisclaimerPopup/DisclaimerPopup";
import bubbleIcon from "../assets/icons/bubble_icon.svg";
import { useParams , useNavigate } from "react-router-dom";

function Homepage() {
    const [isChatBoxOpen, setIsChatBoxOpen] = useState(true);
    const [showDisclaimer, setShowDisclaimer] = useState(false);

    //language from URL
    let [lang, setLang] = useState("pt");
    const {language} = useParams();

    //to set the URL lang
    const navigate = useNavigate(); 
    const browserLanguage = localStorage.getItem("preferredLanguage") || "pt";

    const handleButtonClick = () => {
        // Show disclaimer only if chatbox is being opened and disclaimer hasn't been shown yet
        if (!isChatBoxOpen && !sessionStorage.getItem('disclaimerAccepted')) {
            setShowDisclaimer(true);
        } else {
            setIsChatBoxOpen(!isChatBoxOpen);
        }
    };

    const handleCloseDisclaimer = () => {
        setShowDisclaimer(false);
        setIsChatBoxOpen(true);

        // Store that the disclaimer has been accepted in session storage
        // This prevents the disclaimer from showing again in the same session
        // Comment this line if you want the disclaimer to show every time
        sessionStorage.setItem('disclaimerAccepted', 'true');
    };

  
    useEffect(() =>{
        if(language){
            setLang(language);
            console.log("Language from URL:", language);
        } else {
            navigate(`/${browserLanguage}`)
            setLang(browserLanguage);
            console.log("Language from browser:", browserLanguage);
        }
    }, []);

    return (
        <div className='homepage-container'> 
            <button className="chatbox-open-btn" onClick={handleButtonClick}>
                <img src={bubbleIcon} alt="Bubble Icon" className="bubble-icon" />
            </button>
            {showDisclaimer && <DisclaimerPopup onClose={handleCloseDisclaimer} />}
            {isChatBoxOpen && <ChatBox closeChat={() => setIsChatBoxOpen(false)} language={language} />}
        </div>
    );
}

export default Homepage;